<template lang="pug">
  v-container()
    v-row.justify-center 
      h1( v-html='Inicio.cuerpo.titulo').font-weight-bold.mt-10.mx-12.azul--text.icono-international.icono-grande.pt-5.pl-7
    v-row.justify-center 
      h1.font-weight-light.mb-10.mx-12.azul--text.text-center( v-html='Inicio.cuerpo.subtitulo')

  
    v-row( justify='center' ).fill-height
      template( v-for='{imagen, titulo, marcas} of Inicio.marcas' )
        v-col(cols=6 md=2 ).px-0
          v-card( tile flat color='transparent')
            v-card-text
              v-row.rojo.pa-5.align-center.white-text.mb-1(style='height: 110px; color: white' v-html='titulo')
              v-row.mb-1
                v-img(:src='imagen'  height=160)
              v-row.mb-1(v-for='{nombre, vinculo}, k of marcas' :key='k' flat tile outlined style='height: 60px; border: 1px solid #011c47 !important').my-2.justify-center.align-center
                v-btn.subtitle-1.azul--text.text-uppercase.font-weight-bold.text-center(text  width='100%' :to='{name: "productos", params: {linea_comercial: vinculo}}') {{nombre}}
             

</template>
<script>
import { mapState } from 'vuex'
export default {
  data: ()=>({
  }),
  computed: {
    Inicio() {
      return this.$contenido.Inicio || {}
    },
    ...mapState({
      Reglas: ({Ayudas})=>Ayudas.reglas,
      
    }),
  },
}
</script>